import React, { useEffect, useState,useMemo, useRef } from 'react'; 
import translations from '../../utils/language/translations.json'
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import '../../styles/components/horizontalGrid.scss';
import { Navigate ,useNavigate} from 'react-router-dom';
import LazyImage from "../UsefulComponent/LazyImage"
 import PaginationComponentHorizontalGrid from './PaginationComponentHorizontal';
 import BigShowCompleteCard from '../Card/BigShowCompleteCard';
const HorizontalGrid = ({ data = [], userId, liveCsrfToken }) => {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.HorizontalGrid?.[key]?.[currentLang] || key;
  const navigate = useNavigate();
  const [getShippingPreference, setShippingPreference] = useState(null);
  const [itemStates, setItemStates] = useState([]);
  const [isReady, setIsReady] = useState(false);
  const [isNotEmpty, setIsNotEmpty] = useState(false);
  const [priceChanged, setPriceChanged] = useState({});
  const [sortValue, setSortValue] = useState("");
  const [savedEffect, setSavedEffect] = useState({});
const [removedIds, setRemovedIds] = useState(() => new Set());
  const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage, setItemsPerPage] = useState(10);

const [isMobile, setIsMobile] = useState(false);
 const safeData = useMemo(() => {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.data)) return data.data; // handle API shape {data: []}
    return [];
  }, [data]);



   const didInitRef = useRef(false);
  useEffect(() => {
    if (didInitRef.current) return;
    if (safeData.length === 0) return;

    const initialItemStates = safeData.map((item, idx) => ({
      id: idx,
      price: item.Price,
      shippingPrice: 0,
    }));
    setItemStates(initialItemStates);
    didInitRef.current = true;
  }, [safeData.length]); // <- depend on a stable primitive, not the array object

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  handleResize();
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  useEffect(() => {
    // Fetch shipping preferences
    fetch(`${process.env.REACT_APP_API_BASE}/api/get/shipping-preferences/${userId}`, {
    method: 'GET',
    credentials: 'include',
  })
      .then((response) => response.json())
      .then((preference) => {
        setShippingPreference({
          label: preference.TemplateTitle,
          value: preference.ShippingPreferenceId,
          minorCardShipping: preference.MinorCardShipping,
          mediumCardShipping: preference.MediumCardShipping,
          bigCardShipping: preference.BigCardShipping,
          otherDetails: preference.OtherDetails,
          acceptOffer: preference.acceptOffer,
        });
        console.log('preference', preference);
      })
      .catch((error) => {
        console.log('Error:', error);
      });
  }, [userId]);


  const DisketteSaveIcon = ({ saved, index, item }) => {
    const DisketteSaveBlue = () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="30"
        fill="#0613c6"
        stroke="#0613c6"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <g>
          <path d="M506.513 98.709L413.291 5.486A18.73 18.73 0 00400.047 0H385.77a6.245 6.245 0 00-6.244 6.244v151.114c0 10.345-8.387 18.732-18.732 18.732H151.196c-10.345 0-18.732-8.387-18.732-18.732V6.244A6.245 6.245 0 00126.22 0H18.732C8.387 0 0 8.387 0 18.732v474.537C0 503.613 8.387 512 18.732 512h474.537c10.345 0 18.732-8.387 18.732-18.732V111.954a18.732 18.732 0 00-5.488-13.245zM400.554 410.226c0 10.345-8.387 18.732-18.732 18.732H130.178c-10.345 0-18.732-8.387-18.732-18.732V263.094c0-10.345 8.387-18.732 18.732-18.732h251.644c10.345 0 18.732 8.387 18.732 18.732v147.132z"></path>
          <path d="M176.172 126.138h159.647a6.244 6.244 0 006.244-6.244V6.244A6.245 6.245 0 00335.819 0H176.172a6.245 6.245 0 00-6.244 6.244v113.65a6.245 6.245 0 006.244 6.244zm99.174-79.868c0-10.345 8.387-18.732 18.732-18.732s18.732 8.387 18.732 18.732v33.598c0 10.345-8.387 18.732-18.732 18.732s-18.732-8.387-18.732-18.732V46.27zM318.413 317.93H193.586c-10.345 0-18.732 8.387-18.732 18.732s8.387 18.732 18.732 18.732h124.828c10.345 0 18.73-8.387 18.73-18.732s-8.386-18.732-18.731-18.732z"></path>
        </g>
      </svg>
    );
    const DisketteSaveGrey = () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="30"
        fill="#a1a1a1"
        stroke="#a1a1a1"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <g>
          <path d="M506.513 98.709L413.291 5.486A18.73 18.73 0 00400.047 0H385.77a6.245 6.245 0 00-6.244 6.244v151.114c0 10.345-8.387 18.732-18.732 18.732H151.196c-10.345 0-18.732-8.387-18.732-18.732V6.244A6.245 6.245 0 00126.22 0H18.732C8.387 0 0 8.387 0 18.732v474.537C0 503.613 8.387 512 18.732 512h474.537c10.345 0 18.732-8.387 18.732-18.732V111.954a18.732 18.732 0 00-5.488-13.245zM400.554 410.226c0 10.345-8.387 18.732-18.732 18.732H130.178c-10.345 0-18.732-8.387-18.732-18.732V263.094c0-10.345 8.387-18.732 18.732-18.732h251.644c10.345 0 18.732 8.387 18.732 18.732v147.132z"></path>
          <path d="M176.172 126.138h159.647a6.244 6.244 0 006.244-6.244V6.244A6.245 6.245 0 00335.819 0H176.172a6.245 6.245 0 00-6.244 6.244v113.65a6.245 6.245 0 006.244 6.244zm99.174-79.868c0-10.345 8.387-18.732 18.732-18.732s18.732 8.387 18.732 18.732v33.598c0 10.345-8.387 18.732-18.732 18.732s-18.732-8.387-18.732-18.732V46.27zM318.413 317.93H193.586c-10.345 0-18.732 8.387-18.732 18.732s8.387 18.732 18.732 18.732h124.828c10.345 0 18.73-8.387 18.73-18.732s-8.386-18.732-18.731-18.732z"></path>
        </g>
      </svg>
    );
  
   
    return (
      <button 
    onClick={() => handlePublish(itemStates[index], item.ID, index)}
    disabled={!saved}  // Disable the button if it's not saved
    style={{
      cursor: saved ? 'pointer' : 'not-allowed',  // Show pointer cursor if clickable
      opacity: saved ? 1 : 0.6  // Make the button look less clickable when disabled
    }}
  >
    {saved ? <DisketteSaveBlue /> : <DisketteSaveGrey />}
  </button>
    );
  };
  const heartIconFull =()=>{

    return (  
   
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={25}
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#0066FFED"
        d="M1.243 8.243 8 15l6.757-6.757a4.243 4.243 0 0 0 1.243-3v-.19A4.052 4.052 0 0 0 8.783 2.52L8 3.5l-.783-.98A4.052 4.052 0 0 0 0 5.053v.19c0 1.126.447 2.205 1.243 3Z"
      />
    </svg>
   
    )
   }

  const eyeOpenIcon = () => {
    return ( 
     
       
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          fill="none"
          stroke="#fcfcfc"
          viewBox="0 0 24 24"
        >
          <g
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>{" "}
            <path d="M12.001 5C7.524 5 3.733 7.943 2.46 12c1.274 4.057 5.065 7 9.542 7 4.478 0 8.268-2.943 9.542-7-1.274-4.057-5.064-7-9.542-7z"></path>
          </g>
        </svg>
     
    );
  };



useEffect(() => {
  if (!getShippingPreference) return;

  // Même si aucune carte n'est à vendre, on veut quand même afficher le composant
  if (safeData.length === 0) {
    setIsReady(true);
    return;
  }

  if (itemStates.length > 0) {
    const updatedItemStates = itemStates.map((item) => {
      const price = parseFloat(item.price);
      let shippingPrice = 0;

      if (price <= 15) {
        shippingPrice = getShippingPreference.minorCardShipping;
      } else if (price <= 75) {
        shippingPrice = getShippingPreference.mediumCardShipping;
      } else {
        shippingPrice = getShippingPreference.bigCardShipping;
      }

      return {
        ...item,
        shippingPrice,
      };
    });

    setItemStates(updatedItemStates);
    setIsReady(true);
  }
}, [getShippingPreference, itemStates.length, safeData.length]);
  function handlePriceChange(index, price) {
    const updatedItemStates = [...itemStates];
    updatedItemStates[index].price = parseFloat(price);
  
    if (!getShippingPreference) return;
  
    if (parseFloat(price) <= 15) {
      updatedItemStates[index].shippingPrice = getShippingPreference.minorCardShipping;
    } else if (parseFloat(price) <= 75) {
      updatedItemStates[index].shippingPrice = getShippingPreference.mediumCardShipping;
    } else {
      updatedItemStates[index].shippingPrice = getShippingPreference.bigCardShipping;
    }
  
    setItemStates(updatedItemStates);
    setPriceChanged({ ...priceChanged, [index]: true });
  }

  function handlePublish(itemsStatesChosen, sellCardsID, index) {
    console.log('itemsStatesChosen',itemsStatesChosen)
    const tempoListingSettings = { 
      Price: itemsStatesChosen.price,
      Shipping: itemsStatesChosen.shippingPrice,
      userId: userId,
      ID: sellCardsID,
      liveCsrfToken: liveCsrfToken
    };
    console.log('tempoListingSettings', tempoListingSettings);

    fetch(`${process.env.REACT_APP_API_BASE}/api/marketplace/submitCompleteListing`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(tempoListingSettings),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(() => {
        toast.success(t('Updated'));

           // Apply temporary highlight effect
      setSavedEffect(prev => ({ ...prev, [index]: true }));
      setTimeout(() => {
        setSavedEffect(prev => ({ ...prev, [index]: false }));
      }, 1000);
         // Update the priceChanged state immediately after success
      setPriceChanged((prevPriceChanged) => ({
        ...prevPriceChanged,
        [index]: false, // Set the index of the saved item to false
      }));
     // Log the state to verify if it is getting updated

     console.log('Updated priceChanged state:', priceChanged , 'index',index);
      })
      .catch(error => {
        console.error('Error saving price:', error);
      });
  }

  function handleEditListing(userCardId) {
 navigate(`../EditCard/${userCardId}`)
  }


  function handleNotForSale(userCardId) {
    const tempoListingSettings = { 
      cardIds:[userCardId],
      userId: userId,
      liveCsrfToken: liveCsrfToken,
    };
    console.log('tempoListingSettings', tempoListingSettings);

    fetch(`${process.env.REACT_APP_API_BASE}/api/marketplace/changeStatus/NotForSale`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(tempoListingSettings),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(() => {
        toast.success(t('Updated'));
      setRemovedIds((prev) => {
        const copy = new Set(prev);
        copy.add(userCardId);
        return copy;
      });
      })
      .catch(error => {
        console.error('Error saving price:', error);
      });
  }
  


  function handleSort(e) {
    setSortValue(e.target.value);
    setCurrentPage(1)
  }

  const sortedData = [...safeData].sort((a, b) => {
    switch (sortValue) {
      case 'priceAsc':
        return a.Price - b.Price;
      case 'priceDesc':
        return b.Price - a.Price;
      case 'playerNameAsc':
        return a.Name.localeCompare(b.Name);
      case 'playerNameDesc':
        return b.Name.localeCompare(a.Name);
      case 'cardNameAsc':
        return a.CardName.localeCompare(b.CardName);
      case 'cardNameDesc':
        return b.CardName.localeCompare(a.CardName);
      case 'dateAddedAsc':
        return new Date(a.DateAdded) - new Date(b.DateAdded);
      case 'dateAddedDesc':
        return new Date(b.DateAdded) - new Date(a.DateAdded);
      case 'insertDateAsc':
        return new Date(a.InsertDate) - new Date(b.InsertDate);
      case 'insertDateDesc':
        return new Date(b.InsertDate) - new Date(a.InsertDate);
        case 'viewsAsc':
          return a.ViewCounts - b.ViewCounts;
        case 'viewsDesc':
          return b.ViewCounts - a.ViewCounts;
        case 'watchlistAsc':
          return a.WatchListCounts - b.WatchListCounts;
        case 'watchlistDesc':
          return b.WatchListCounts - a.WatchListCounts;
      default:
        return 0;
    }
  });


//   const totalPages = Math.ceil(sortedData.length / itemsPerPage);
// const paginatedData = sortedData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const visibleData = useMemo(
    () => sortedData.filter((item) => !removedIds.has(item?.userCardId)),
    [sortedData, removedIds]
  );
  const totalPages = Math.max(1, Math.ceil(visibleData.length / itemsPerPage));
  const paginatedData = useMemo(
    () => visibleData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage),
    [visibleData, currentPage, itemsPerPage]
  );
const visibleCardIds = paginatedData.map((card) => card.userCardId); // Extract IDs
  
// Reset item states and priceChanged when sorting changes
  useEffect(() => {
    if (safeData.length === 0) return;

    // If you truly need to reset itemStates on sort change:
    const reset = safeData.map((item) => ({
      price: item.Price,
      shippingPrice: 0,
    }));

    // Avoid useless setState loops: only set if it actually changed
    setItemStates((prev) => {
      if (prev.length === reset.length &&
          prev.every((p, i) => p.price === reset[i].price && p.shippingPrice === reset[i].shippingPrice)) {
        return prev; // no change
      }
      return reset;
    });

    setPriceChanged({});
  }, [sortValue, safeData.length]);
  useEffect(() => {
  const lastPage = Math.max(1, Math.ceil(visibleData.length / itemsPerPage));
  if (currentPage > lastPage) setCurrentPage(lastPage);
}, [visibleData.length, itemsPerPage, currentPage]);

  function validateLabel(value, label) {
    switch (label) {
      case "IsRookie":
        if (value === "Rookie(RC)") return true;
        else return false;
      case "IsPatch":
        if (value === "Patch") return true;
        else return false;
      case "IsJersey":
        if (value === "Jersey") return true;
        else return false;
      case "IsAuto":
        if (value === "Auto") return true;
        else return false;
      case "IsTribute":
        if (value === 1) return true;
        else return false;
      case "Numbered":
        return true;
      case "isPC":
        if (value === "isPC") return true;
        else return false;
      case "isForSale":
        if (value === "isForSale") return true;
        else return false;
      case "isForTrade":
        if (value === "isForTrade") return true;
        else return false;
      case "isOnEbay":
        if (value === "isOnEbay") return true;
        else return false;
      case "Graded":
        if (value === "Graded"||value==="Raw")  return true;
        else return false;
      case "GradeCompany":
        if (value !== (" " || "")) return true;
        else return false;
      case "Grade":
        if (parseInt(value) >= 1 && parseInt(value) <= 10) return true;
        else return false;
        case "Added On ":
          if(value!==null)
          return true;
        else return false;
    }
  }
  //&& validateLabel(value, label)
  const renderAttributeSquare = (value, label) => {
  
    return value&& validateLabel(value, label)  ? (
      <label className="pill">{`${value}`}</label>
    ) : null;
  };


  const renderAttributeGrading = (GradingCompany, Grade, label) => {
    if (!GradingCompany) return null;

    console.log("GradingCompany, Grade, label", GradingCompany, Grade, label);

    return (
      <div  styte={{justifyContent: 'center',gap:'0px'}}>
        
        
          <button
            className={`patch-grading ${GradingCompany.toLowerCase()} HorizontalGrid`}
          >
            {`${GradingCompany} ${Grade}`}
          </button>
       
      </div>
    );
  };

const hasNoListings = visibleData.length === 0;
 
return (
  isReady && (
    <div className="horizontalGrid">
      {hasNoListings ? (
   <div className="horizontalGrid-emptyState">
  <div className="horizontalGrid-emptyState__card">
    <div className="horizontalGrid-emptyState__icon">🏷️</div>

    <div className="horizontalGrid-emptyState__content">
      <h3>{t("No cards listed for sale yet")}</h3>
      <p>{t("Put at least one card for sale to access this section.")}</p>

      <button
        className="horizontalGrid-emptyState__button btn-baseBlue"
        onClick={() =>
          navigate(i18n.language === "fr" ? "/fr/my-collection" : "/my-collection")
        }
      >
        {t("Go to My Collection")}
      </button>
    </div>
  </div>
</div>
      ) : (
        <>
          <div
            style={{
              marginBottom: "10px",
              marginTop: "3rem",
              paddingBottom: "0px",
              display: "block",
            }}
          >
            <select
              value={sortValue}
              onChange={handleSort}
              className="custom-select-simple"
              style={{ maxWidth: "fit-content" }}
            >
              <option value=" ">{t("Order By")}</option>
              <option value="viewsAsc">{t("Views (Low to High)")}</option>
              <option value="viewsDesc">{t("Views (High to Low)")}</option>
              <option value="watchlistAsc">{t("Watchlist (Low to High)")}</option>
              <option value="watchlistDesc">{t("Watchlist (High to Low)")}</option>
              <option value="priceAsc">{t("Price/Value (Low to High)")}</option>
              <option value="priceDesc">{t("Price/Value (High to Low)")}</option>
              <option value="playerNameAsc">{t("Player Name (A-Z)")}</option>
              <option value="playerNameDesc">{t("Player Name (Z-A)")}</option>
              <option value="cardNameAsc">{t("Card Name (A-Z)")}</option>
              <option value="cardNameDesc">{t("Card Name (Z-A)")}</option>
              <option value="dateAddedAsc">{t("Time as ForSale (Oldest to Newest)")}</option>
              <option value="dateAddedDesc">{t("Time as ForSale (Newest to Oldest)")}</option>
              <option value="insertDateAsc">{t("Added Date (Oldest to Newest)")}</option>
              <option value="insertDateDesc">{t("Added Date (Newest to Oldest)")}</option>
            </select>
          </div>

          <PaginationComponentHorizontalGrid
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
          />

          {isMobile ? (
            <div className="mobile-grid">
              {paginatedData.map((item, index) => (
                <div className="mobile-card-wrapper" key={index}>
                  <div className="buttons">
                    <button
                      className="button-edit"
                      onClick={() => handleEditListing(item.userCardId)}
                    >
                      {t("Edit Listing")}✏️
                    </button>
                    <button
                      className="button-remove"
                      onClick={() => handleNotForSale(item.userCardId)}
                    >
                      {t("Not For Sale")}❌
                    </button>
                    <div className="stats">
                      👁 {item.ViewCounts} | 💙 {item.WatchListCounts}
                    </div>
                  </div>

                  <div
                    className="marginCenter"
                    style={{ justifyContent: "center", display: "flex" }}
                  >
                    <BigShowCompleteCard
                      formData={item}
                      isForCreate={false}
                      showProfile={false}
                      showPrice={false}
                      useMinHeight={true}
                      regularSize={true}
                    />
                  </div>

                  <div className="mobile-actions">
                    <div className="price-section">
                      <label>{t("Price")}:</label>
                      <input
                        className="InputBigPrice"
                        value={itemStates[index]?.price}
                        onChange={(e) => handlePriceChange(index, e.target.value)}
                      />
                      $
                    </div>

                    <div className="buttons">
                      <button
                        className="btn-baseBlue"
                        onClick={() => handlePublish(itemStates[index], item.ID, index)}
                        disabled={!priceChanged[index]}
                      >
                        {t("Save")}💾
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <>
              <table
                style={{
                  margin: "auto",
                  borderCollapse: "collapse",
                  width: "100%",
                }}
                className="horizontalGrid"
              >
                <thead>
                  <tr style={{ borderBottom: "2px solid black" }}>
                    <th style={{ width: "6vw" }}>{t("FrontPicture")}</th>
                    <th style={{ width: "6vw" }}>{t("BackPicture")}</th>
                    <th style={{ width: "14vw" }}>{t("Card")}</th>
                    <th style={{ width: "4vw" }}>{t("Condition")}</th>
                    <th style={{ width: "1vw" }}>{t("Save")}</th>
                    <th style={{ width: "14vw" }}>{t("Price")}</th>
                    <th style={{ width: "6vw" }}>{t("Options")}</th>
                    <th style={{ width: "6vw" }}>Stats</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedData.map((item, index) => {
                    const isVisible = visibleCardIds.includes(item.userCardId);

                    return (
                      <tr key={index}>
                        <td>
                          <img
                            style={{ width: 115, height: 115 }}
                            src={item.ImageFront || undefined}
                            alt={`Card ${index}`}
                            isVisible={isVisible}
                          />
                        </td>

                        <td>
                          <img
                            style={{ width: 115, height: 115 }}
                            src={item.ImageUserBack || undefined}
                            alt={`Card ${index}`}
                            isVisible={isVisible}
                          />
                        </td>

                        <td>
                          <p>
                            {item.Name}{" "}
                            {item.NumberBehind && <span>#{item.NumberBehind}</span>}
                            <br />
                            {item.SetName}
                            <br />
                            {item.cardName} - {item.variationName}
                          </p>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              gap: "10px",
                              flexWrap: "wrap",
                            }}
                          >
                            {renderAttributeSquare(item.IsRookie, "IsRookie")}
                            {renderAttributeSquare(item.IsPatch, "IsPatch")}
                            {renderAttributeSquare(item.IsJersey, "IsJersey")}
                            {renderAttributeSquare(item.IsAuto, "IsAuto")}
                            {parseInt(item.Numbered) > 0 &&
                              renderAttributeSquare("/" + item.Numbered, "Numbered")}
                          </div>
                        </td>

                        <td>
                          {item.Graded === 0 || item.Graded === false ? (
                            <p>{item.ConditionCard}</p>
                          ) : (
                            <>{renderAttributeGrading(item.GradeCompany, item.Grade)}</>
                          )}
                        </td>

                        <td>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "100%",
                              marginBottom: "1vw",
                            }}
                          >
                            <DisketteSaveIcon
                              saved={priceChanged[index]}
                              index={index}
                              item={item}
                            />
                          </div>
                        </td>

                        <td>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <label style={{ width: "4vw", textAlign: "left" }}>
                              {t("Price")} ($)
                            </label>
                            <label style={{ width: "4vw", textAlign: "center" }}>
                              {t("Shipping")}
                            </label>
                            <label style={{ width: "5vw", textAlign: "center" }}>
                              Total
                            </label>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <input
                              style={{
                                width: "4vw",
                                textAlign: "center",
                                color: "black",
                                fontWeight: "bold",
                                backgroundColor: savedEffect[index]
                                  ? "#4CAF50"
                                  : "white",
                                transition: "background-color 0.5s ease-in-out",
                              }}
                              type="text"
                              value={itemStates[index]?.price || 0}
                              onChange={(e) => handlePriceChange(index, e.target.value)}
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^0-9.]/g, "");
                              }}
                              disabled={!getShippingPreference}
                              maxLength={6}
                              onClick={(e) => e.target.select()}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" && priceChanged[index]) {
                                  handlePublish(itemStates[index], item.ID, index);
                                  const nextInput = document.querySelector(
                                    `#price-input-${index + 1}`
                                  );
                                  if (nextInput) {
                                    nextInput.focus();
                                    nextInput.select();
                                  }
                                } else if (e.key === "Tab") {
                                  e.preventDefault();
                                  const nextInput = document.querySelector(
                                    `#price-input-${index + 1}`
                                  );
                                  if (nextInput) {
                                    nextInput.focus();
                                    nextInput.select();
                                  }
                                }
                              }}
                              id={`price-input-${index}`}
                            />

                            <label>+</label>

                            <input
                              style={{
                                width: "3vw",
                                textAlign: "center",
                                backgroundColor: "lightgrey",
                                color: "black",
                                fontWeight: "bold",
                              }}
                              type="text"
                              value={itemStates[index]?.shippingPrice || 0}
                              disabled
                            />

                            <label>=</label>

                            <div
                              style={{
                                fontWeight: "bold",
                                width: "5vw",
                                textAlign: "center",
                                whiteSpace: "nowrap",
                              }}
                            >
                              $
                              {(
                                (itemStates[index]?.price || 0) +
                                (itemStates[index]?.shippingPrice || 0)
                              ).toFixed(2)}
                            </div>
                          </div>

                          <div style={{ marginRight: "2vw", marginTop: "1vw" }}>
                            <p>
                              {t("Paid")} ${item.PaidPrice}
                            </p>
                          </div>
                        </td>

                        <td style={{ textAlign: "center", padding: "8px" }}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                              height: "100%",
                            }}
                          >
                            <button
                              type="button"
                              className="action-btn action-btn--edit"
                              onClick={() => handleEditListing(item.userCardId)}
                              aria-label={t("Edit Listing")}
                            >
                              {t("Edit Listing")}
                            </button>

                            <button
                              type="button"
                              className="action-btn action-btn--danger"
                              onClick={() => handleNotForSale(item.userCardId)}
                              aria-label={t("Not For Sale")}
                            >
                              {t("Not For Sale")}
                            </button>
                          </div>
                        </td>

                        <td>
                          <div className="stat-container">
                            <div className="stat-item">
                              <div className="icon-row">{eyeOpenIcon()}</div>
                              <div className="label-row">
                                <span className="stat-label">{t("Views")}:</span>
                                <span>{item.ViewCounts}</span>
                              </div>
                            </div>

                            <div className="stat-item">
                              <div className="icon-row">{heartIconFull()}</div>
                              <div className="label-row">
                                <span className="stat-label">{t("Watchlist")}:</span>
                                <span>{item.WatchListCounts}</span>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          )}

          <PaginationComponentHorizontalGrid
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
          />
        </>
      )}
    </div>
  )
);
}

export default HorizontalGrid;
